import { axiosClient } from '../services/axiosClient';

const normalizeUrlForAxiosBaseURL = (url) => {
  if (!url) return url;
  // axios treats a URL starting with '/' as absolute (it overrides baseURL path).
  // We want calls like '/api/users/...' to become 'users/...' so they join with baseURL '/api'
  // and remain proxyable in dev.
  return url.startsWith('/api/') ? url.slice(5) : url;
};

// Base query routing every request through the shared axiosClient instance.
// Auth headers + refresh/retry are handled by axios interceptors.
export const baseQueryWithAuth = async (args) => {
  try {
    const request = typeof args === 'string' ? { url: args } : args;
    const url = normalizeUrlForAxiosBaseURL(request.url);

    console.log('[GLOW][baseQueryWithAuth] request', {
      method: (request.method || 'GET').toUpperCase(),
      url: request.url,
      normalizedUrl: url,
    });

    const result = await axiosClient({
      url,
      method: request.method,
      data: request.body,
      params: request.params,
      headers: request.headers,
    });

    console.log('[GLOW][baseQueryWithAuth] response', {
      method: (request.method || 'GET').toUpperCase(),
      url: request.url,
      status: result?.status,
    });

    return { data: result.data };
  } catch (axiosError) {
    const status = axiosError?.response?.status;
    const data = axiosError?.response?.data ?? axiosError?.message;

    console.log('[GLOW][baseQueryWithAuth] error', {
      method: (typeof args === 'string' ? 'GET' : (args?.method || 'GET')).toUpperCase(),
      url: typeof args === 'string' ? args : args?.url,
      status,
    });

    return {
      error: {
        status: status ?? 'FETCH_ERROR',
        data,
      },
    };
  }
};
